"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetTypes = void 0;
var WidgetTypes;
(function (WidgetTypes) {
    WidgetTypes["QUICK_GLANCE"] = "quick_glance";
    WidgetTypes["BUTTON_ICON"] = "button_icon";
    WidgetTypes["BUTTON_TEXT"] = "button_text";
    WidgetTypes["BUTTON_HEADER"] = "button_header";
    WidgetTypes["BUTTON_CONTENT_SWITCHER"] = "button_content_switcher";
    WidgetTypes["BUTTON_ESSENTIAL_INFO"] = "button_essential_info";
    WidgetTypes["BANNER"] = "banner";
    WidgetTypes["MAIN_DETERMINANT"] = "main_determinant";
    WidgetTypes["SUB_DETERMINANT_BADGE"] = "sub_determinant_badge";
})(WidgetTypes || (exports.WidgetTypes = WidgetTypes = {}));
